/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlLicenseResponse
 */
export interface ControlLicenseResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlLicenseResponse
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLicenseResponse
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLicenseResponse
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLicenseResponse
     */
    monit_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLicenseResponse
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLicenseResponse
     */
    updated?: string;
}

/**
 * Check if a given object implements the ControlLicenseResponse interface.
 */
export function instanceOfControlLicenseResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlLicenseResponseFromJSON(json: any): ControlLicenseResponse {
    return ControlLicenseResponseFromJSONTyped(json, false);
}

export function ControlLicenseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLicenseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'monit_type': !exists(json, 'monit_type') ? undefined : json['monit_type'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function ControlLicenseResponseToJSON(value?: ControlLicenseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'monit_type': value.monit_type,
        'created': value.created,
        'updated': value.updated,
    };
}

